import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllHolidays = createAsyncThunk(
  'holidayCharge/getAllHolidays',
  async ({ page = 1, limit = 10 }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/holidays?limit=${limit}&page=${page}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const addNewHoliday = createAsyncThunk('holidayCharge/addNewHoliday', async (data, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/holidays`, { ...data });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteHolidayById = createAsyncThunk('holidayCharge/deleteHolidayById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/holidays/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateHolidayById = createAsyncThunk(
  'holidayCharge/updateHolidayById',
  async ({ id, payload }, thunkAPI) => {
    try {
      await axiosInstance.put(`/holidays/${id}`, { ...payload });
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getHolidayDetail = createAsyncThunk('holidayCharge/getHolidayDetail', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/holidays/${id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getAllEvents = createAsyncThunk(
  'events/getAllEvents',
  async ({ page = 1, limit = 10, locationId }, thunkAPI) => {
    try {
      let mainUrl = `/events?limit=${limit}&page=${page}`;

      if (locationId) {
        mainUrl += `&location_id=${locationId}`;
      }

      const response = await axiosInstance.get(mainUrl);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const addNewEvent = createAsyncThunk('events/addNewEvent', async (data, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/events`, { ...data });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteEventById = createAsyncThunk('events/deleteEventById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/events/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateEventById = createAsyncThunk('events/updateEventById', async ({ id, payload }, thunkAPI) => {
  try {
    await axiosInstance.put(`/events/${id}`, { ...payload });
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getEventDetail = createAsyncThunk('events/getEventDetail', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/events/${id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
